import { useEffect, useState } from 'react';
import { httpClient } from 'services/httpClient';

export interface OrganizationOption {
  label: string;
  value: number;
}

const ORGANIZATIONS_LIMIT = 1000;

export function useOrganizationOptions() {
  const [options, setOptions] = useState<OrganizationOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    setLoading(true);
    httpClient
      .get('/admin/organizations', {
        params: { page: 1, limit: ORGANIZATIONS_LIMIT }
      })
      .then(response => {
        if (!mounted) return;

        const items: { id: number | string; name: string }[] =
          response.data?.data ?? [];

        setOptions(
          items
            .map(item => ({ label: item.name, value: Number(item.id) }))
            .sort((a, b) => a.label.localeCompare(b.label))
        );
      })
      .catch(() => {})
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return {
    selectProps: {
      options,
      loading,
      showSearch: true,
      filterOption: (input: string, option?: { label?: unknown }) =>
        String(option?.label ?? '')
          .toLowerCase()
          .includes(input.trim().toLowerCase())
    }
  };
}
